export const modeCommandeOverviewProps = () => ({
  modeCommande: {
    type: Object,
    required: true
  }
});

export const modeCommandeOverviewEmits = () => ([
  "callToAction",
  "actionSecondaire"
]);

export const useModeCommandeOverview = (props, context) => {
  const image = computed(() => {
    // Exemple :  assets/images/modes-commande/drive.jpg
    // correspond à mode_commande.type dans l'api
    return modesCommande[props.modeCommande.type.toLowerCase()];
  })
  const titre = computed(() => {
    return props.modeCommande.label_long;
  })
  const accroche = computed(() => {
    switch (props.modeCommande.type) {
      case "LAD":
        return "Vos courses livrées chez vous";
      case "PRP":
        return "Retirez vos courses dans les points de retrait";
      case "CC":
        return "Réservez vos produits et retirez-les en magasin";
      case "CEV":
        return "Retrait dans votre magasin en plein coeur de ville";
      case "LC":
        return "Confiez la livraison de vos courses à un livreur particulier";
      case "PRC":
        return "Retrait dans un conteneur Easybox";
      case "PRC_DELIPOP":
        return "Retrait autonome chez Delipop"
    }
    return "Vos courses directement dans votre coffre";
  })
  const premierCreneau = computed(() => {
    if (props.modeCommande.prochain_creneau && props.modeCommande.prochain_creneau.jour_debut && props.modeCommande.prochain_creneau.heure_debut) {
      return `dès ${lowercaseFirstLetter(props.modeCommande.prochain_creneau.jour_debut)} à ${props.modeCommande.prochain_creneau.heure_debut}`;
    }
    return "Horaires indisponibles"
  })
  const cta = computed(() => {
    switch (props.modeCommande.type) {
      case "LAD":
        return "Vérifier ma ville";
      case "PRP":
        return "Trouver un point de retrait";
      case "CC":
        return "En savoir plus";
      case "LC":
        return "En savoir plus";
    }
    return "Voir le planning";
  })
  const tarif = computed(() => {
    return props.modeCommande.tarif_mini;
  })

  const ctaAction = () => {
    context.emit("callToAction", props.modeCommande.type)
  }
  const actionSecondaire = () => {
    context.emit("actionSecondaire", props.modeCommande.type)
  }

  return {
    image,
    titre,
    accroche,
    premierCreneau,
    cta,
    tarif,
    ctaAction,
    actionSecondaire
  }
}